function closeOptionsModal() {
  const closeBtn = document.querySelectorAll('.mailchimp-modal-close');
  if (closeBtn) {
    Array.prototype.forEach.call(
      closeBtn,
      (el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const chimpPopup = document.getElementById('mailchimp_options_popup');
          const newsPopup = document.getElementById('newsletter_popup');
          const modalBGs = document.getElementsByClassName('modal-backdrop');
          chimpPopup.classList.remove('show');
          if (newsPopup && modalBGs) {
            newsPopup.classList.remove('show');
            newsPopup.setAttribute('aria-hidden', 'true');
            newsPopup.setAttribute('style', 'display: none');
            document.body.classList.remove('modal-open');
            for (let i = 0; i < modalBGs.length; i += 1) {
              document.body.removeChild(modalBGs[i]);
            }
          }
        });
      }
    );
  }
}

window.load = closeOptionsModal();
